import { Dropdown, MenuProps } from 'antd';
import { MoreVerticalIcon } from '../../../../components/icons';
import { useBankLogos } from '../../../../customhooks/useBankLogos';
import { TreasuryAccount } from '../../../../interfaces/Treasury';
import { formatDate } from '../../../../utils/helper';

interface TreasuryAccountMobileCardProps {
    item?: TreasuryAccount;
    onClick?: () => void;
    getMenu?: (record: TreasuryAccount) => MenuProps['items'];
}

const TreasuryAccountMobileCard = ({
    item,
    onClick = () => {},
    getMenu
}: TreasuryAccountMobileCardProps) => {
    const { loading: loadingLogos, getBankByCode } = useBankLogos();

    return (
        <div className='bg-white' onClick={onClick}>
            <div className='flex  gap-[12px] border border-appcolorfaintnine border-b border-0 w-full py-[20px]'>
                <div className='w-[40px] h-[40px] rounded-[50%] overflow-hidden border border-[#D0D5DD] flex items-center justify-center'>
                    <img
                        src={getBankByCode(String(item?.code))?.logo}
                        alt='bank-logo'
                        className='object-contain w-full h-full'
                    />
                </div>

                <div>
                    <div className='flex justify-between'>
                        <p className='text-sm font-semibold leading-5 text-ebony mb-[8px]'>
                            {item?.name}
                        </p>
                        <Dropdown
                            menu={{
                                items: item && getMenu && getMenu(item)
                            }}
                            trigger={['click']}
                        >
                            <div
                                className='rotate-90 flex flex-row justify-center cursor-pointer'
                                onClick={(e) => e.stopPropagation()}
                            >
                                <MoreVerticalIcon />
                            </div>
                        </Dropdown>
                    </div>

                    <p className='text-xs font-normal leading-[18px] text-paleSky mb-[4px]'>
                        Name:{' '}
                        <span className='font-bold'>{item?.accountName}</span>
                    </p>
                    <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                        <p className='text-xs font-normal leading-[18px] text-paleSky'>
                            Balance:
                            <span className='font-semibold'>
                                NGN {item?.accountBalance}
                            </span>
                        </p>
                        <p className='text-xs font-normal leading-[18px] text-paleSky'>
                            Connect at:{' '}
                            <span className='font-semibold'>
                                {formatDate(item?.createdDate, 'DD-MM-YYYY')}
                            </span>
                        </p>
                        <p className='text-xs font-normal leading-[18px] text-paleSky'>
                            Status:{' '}
                            <span className='font-semibold'>
                                {item?.connectStatus}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TreasuryAccountMobileCard;
